import EventsSerializer from './base';

export default class Mitigation extends EventsSerializer {}
